import script from "./PlayerScore.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerScore.vue?vue&type=script&setup=true&lang=js"

import "./PlayerScore.vue?vue&type=style&index=0&id=1a49ef90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a49ef90"]])

export default __exports__